export const environment = {
  production: true,
  providers: [],
};
